export default function array_sum (array) {
  //   example 1: array_sum([4, 9, 182.6])
  //   returns 1: 195.6
  //   example 2: var $total = []
  //   example 2: var $index = 0.1
  //   example 2: for (var $y = 0; $y < 12; $y++){ $total[$y] = $y + $index }
  //   example 2: array_sum($total)
  //   returns 2: 67.2

	var key
	var sum = 0
	
	// input sanitation
	if (typeof array !== 'object') {
	    return null
	}
	
	for (key in array) {
	    if (!isNaN(parseFloat(array[key]))) {
	      sum += parseFloat(array[key])
	    }
	}
	
	return sum
}


// WEBPACK FOOTER //
// ./src/assets/js/lib/array_sum.js